module.exports = __webpack_public_path__ + "static/cashew_nuts_nong_cu_1-10c3f86bf6b5ddf4fa2ab70aff82f205.jpg";